/** La scheda dell'azienda nella console (24/10/2026): per ora il blocco dell'accesso. Gemello di `en.ts`. */
export default {
  accesso: {
    titolo: 'Accesso dell’azienda',
    spiegazione_libera: 'Il blocco chiude gli account di chi lavora per questa azienda e la sospende: nessuno entra più, né dal gestionale né dalle app del telefono. I dati restano tutti, e lo sblocco rimette le cose com’erano.',
    bloccata_dal: 'Accesso bloccato dal {{quando}}',
    bloccata_motivo: 'Motivo: {{motivo}}',
    bloccata_da_skill: 'dalla skill /probusiness',
    bloccata_da_console: 'dalla console',
    bottone_blocca: 'Blocca l’accesso…',
    bottone_sblocca: 'Sblocca l’accesso…',
    titolo_blocco: 'Bloccare l’accesso di {{nome}}?',
    titolo_sblocco: 'Sbloccare l’accesso di {{nome}}?',
    caricamento: 'Preparo il resoconto…',
    piano: 'Piano {{piano}}',
    esente: 'Esente: {{motivo}}',
    esente_senza_motivo: 'Esente, senza motivo scritto',
    abbonamento: 'Abbonamento {{id}} ({{stato}})',
    nessun_abbonamento: 'Nessun abbonamento su Stripe',
    ultimo_pagamento: 'ultimo pagamento il {{quando}}',
    pagato_in_passato: 'ha pagato in passato',
    mai_pagato: 'mai pagato',
    ultima_attivita_azienda: 'L’ultima volta che qualcuno dell’azienda ha usato il sistema: {{quando}}',
    mai: 'mai',
    si_chiudono_one: 'Si chiude {{count}} account',
    si_chiudono_other: 'Si chiudono {{count}} account',
    si_riaprono_one: 'Si riapre {{count}} account',
    si_riaprono_other: 'Si riaprono {{count}} account',
    nessuno: 'Nessuno.',
    restano_chiusi: 'Restano chiusi: li tiene chiusi anche altro',
    gia_chiusi: 'Già chiusi prima: restano chiusi, e lo sblocco non li riapre',
    non_si_toccano: 'Non si toccano',
    chiuso_da: 'chiuso da: {{chi}}',
    chiuso_prima_del_registro: 'chiuso prima del registro dei blocchi',
    persona_attivita: 'Ultima attività {{attivita}} · ultimo ingresso {{ingresso}}',
    senza_ruolo: 'ruolo non scritto',
    cosa_succede_blocco: 'L’azienda diventa «sospesa» (il gestionale mostra la schermata di blocco), gli account qui sopra si chiudono e le sessioni aperte cadono, anche nelle app del telefono (al più entro un’ora). I dati restano tutti e i profili delle persone non si toccano.',
    cosa_succede_sblocco: 'L’azienda torna allo stato di prima del blocco e si riaprono solo gli account che il blocco aveva chiuso e che nient’altro tiene chiusi.',
    motivo: 'Perché',
    motivo_aiuto_blocco: 'Resta nello storico dell’azienda (es. «mai pagato, sparita da ottobre»).',
    motivo_aiuto_sblocco: 'Facoltativo: resta nello storico dell’azienda.',
    annulla: 'Annulla',
    conferma_blocco_one: 'Blocca l’accesso ({{count}} account)',
    conferma_blocco_other: 'Blocca l’accesso ({{count}} account)',
    conferma_sblocco: 'Sblocca l’accesso',
    esito_blocco: 'Accesso bloccato: {{count}} account chiusi.',
    esito_sblocco: 'Accesso sbloccato: {{count}} account riaperti.',
    esito_restano: '{{count}} restano chiusi per altri motivi.',
    esito_errori: '{{count}} account non si sono potuti cambiare: guarda i registri.',
    errore: 'Non riuscito: {{messaggio}}',
    motivi: {
      super_utente: 'super utente, mai',
      agente: 'agente WhatsApp, non è una persona',
      lavora_anche_per_altre_aziende: 'lavora anche per un’altra azienda: l’account resta, qui perde l’accesso perché l’azienda è sospesa',
      ospite_da_altra_azienda: 'lavora qui da un’altra azienda: l’account è dell’altra, qui perde l’accesso perché l’azienda è sospesa',
      account_senza_azienda: 'account senza azienda nei permessi (uno schermo, un account di servizio): lo chiude il supporto',
      account_inesistente: 'profilo senza account: non c’è niente da chiudere',
    },
    impedimenti: {
      gia_bloccata: 'L’accesso di questa azienda è già bloccato.',
      non_bloccata: 'L’accesso di questa azienda non è bloccato: non c’è niente da sbloccare.',
      abbonamento_vivo: 'L’azienda ha un abbonamento ancora vivo su Stripe: prima si chiude quello, poi si blocca l’accesso.',
    },
  },
} as const;
